export const COOKIE_COUNTRY = 'sharesight_country';
